import { changeModalVisibility, setFoodsList, setFoodToView, setFoodToEdit } from '../../../store/foodsSlice';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Button from '../../BaseComponents/Button';
import FoodsModal from './FoodsModal';
import ViewFoodModal from './FoodsModal/ViewFoodModal';
import DeleteFood from './FoodsModal/DeleteFoodModal';
import FoodsTableMedicalLibrary from './FoodsTable';
import { RootState } from '../../../store/store';
import { getFoodList } from '../../../api/food';

const Foods = () => {
  const dispatch = useDispatch();
  const { isAddFoodModalOpened, isDeleteFoodModalOpened, foodToView, foodsList } =
    useSelector((state: RootState) => state.foods);

  const handleSearch = async (searchValue: string) => {
    try {
      const foodsListResp = await getFoodList(searchValue);
      dispatch(setFoodsList(foodsListResp));
    } catch (error) {
      console.error('Error searching foods:', error);
    }
  };

  return (
    <div>
      <div className='search-row-container'>
        <div className='search-and-filter-container d-flex align-items-center gap-20'>
          <div className="search-input-container">
            <input
              type="text" 
              className="search-input"
              placeholder="Search Foods..."
              onChange={(e) => {
                handleSearch(e.target.value);
              }}
            />
          </div>
          <div className='count-container'> {foodsList?.foods?.length || 0} {foodsList?.foods?.length === 1 ? 'Food' : 'Foods'}</div>
        </div>
        <Button
          isSecondary={true}
          text='Add Food'
          onClick={() => {
            dispatch(setFoodToEdit(null));
            dispatch(changeModalVisibility(true));
          }}
        />
      </div>
      <FoodsTableMedicalLibrary />
      <FoodsModal isOpen={isAddFoodModalOpened} />
      <DeleteFood isOpen={isDeleteFoodModalOpened} />
      <ViewFoodModal
        isOpen={foodToView !== null}
        onClose={() => {
          dispatch(setFoodToView(null));
        }}
      />
    </div>
  );
};

export default Foods;
